export const symbol = {
    emoji: 'beginner',
    emojiUnicode: '🔰',
    colorToken: 'symbol-skin-1'
}